import {IAppInfo} from "./AppInfo";
import {ApplicationInsights, DistributedTracingModes, ITelemetryItem} from "@microsoft/applicationinsights-web";

export const InitialiseAppInsights = (appInfo: IAppInfo) => {
    if (!appInfo) {
        return null;
    }
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: appInfo.AppInsightsKey,
            distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
            disableFetchTracking: false,
            enableCorsCorrelation: true,
            enableAutoRouteTracking: true,
        },
    });
    return appInsights;
};

export const AppInsightsLoggingForTeams = (
    appInfo: IAppInfo,
    appInsights: ApplicationInsights,
    tenantId: string,
    teamsId: string,
    userId: string
) => {
    appInsights.loadAppInsights();

    appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
        const telemetryItem = envelope.baseData;

        // extreme paranoia - extra safe logging
        function trySetProp(propName: string, getter: () => string) {
            try {
                telemetryItem.properties[propName] = getter();
            } catch (err) {
                console.log("AI:Property:" + propName + ":" + err.message);
            }
        }

        telemetryItem.properties = telemetryItem.properties || {};
        trySetProp("ApplicationEnvironment", () => appInfo.ApplicationEnvironment);
        trySetProp("BuildNumber", () => appInfo.BuildNumber);
        trySetProp("Branch", () => appInfo.Branch);
        trySetProp("Commit", () => appInfo.Commit);

        trySetProp("TenantId", () => tenantId);
        trySetProp("TeamsId", () => teamsId);
        trySetProp("UserId", () => userId);
    });

    appInsights.setAuthenticatedUserContext(userId, null, true);
};
